<template>
  <el-select
    class="select-dict"
    :style="{ width: width }"
    :size="size"
    v-model="dictValue"
    :loading="isLoading"
    filterable
    remote
    :remote-method="getList"
    placeholder="请选择"
    :clearable="clearable"
    :multiple="multiple"
    :disabled="disabled"
  >
    <el-option
      v-for="item in list"
      :label="item.name"
      :value="item.value"
      :key="item.value"
    ></el-option>
  </el-select>
</template>

<script>
import { getDictEnumListAPI } from "@/enum/dict/index.js";

export default {
  name: "SelectDict",

  props: {
    value: {
      type: [String, Array, Number],
      default: "",
    },
    dictCode: {
      type: String,
      default: "",
    },
    width: {
      type: String,
      default: "500px",
    },
    size: {
      type: String,
      default: "small",
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    dictValue: {
      get() {
        return this.value;
      },

      set(val) {
        this.$emit("input", val);
      },
    },
  },

  data() {
    return {
      list: [],
      isLoading: false,
      loaded: false, // 字典是否已加载完成，避免列表未就绪时误清值
    };
  },

  created() {
    this.getList("");
  },

  watch: {
    // 值变化时再对齐检查（列表加载完成时的初次检查在 getList 里做）
    value() {
      this.handleInvalidValue();
    },
  },

  methods: {
    async getList() {
      this.list = await getDictEnumListAPI(this.dictCode);
      this.loaded = true;
      this.handleInvalidValue();
    },
    // 字典选项被删除/变更后，清掉当前值中列表里已不存在的项，避免回显原始 code
    handleInvalidValue() {
      if (!this.loaded) return;
      const { list, value } = this;
      if (this.multiple) {
        if (!Array.isArray(value) || value.length === 0) return;
        const valid = value.filter(v => list.some(o => o.value === v));
        if (valid.length !== value.length) {
          this.$emit("input", valid);
          // this.$message.warning("部分选项已失效，已自动移除，请重新选择");
        }
      } else {
        if (value === "" || value === null || value === undefined) return;
        const hit = list.some(o => o.value === value);
        if (!hit) {
          this.$emit("input", "");
          // this.$message.warning("该选项已失效，已自动清空，请重新选择");
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.el-select /deep/ {
  .el-select__caret:first-child::before {
    content: "\e6e1";
  }
  .is-focus {
    .el-select__caret:first-child {
      transform: rotateZ(0deg);
    }
  }
}
</style>
